import { render, staticRenderFns } from "./form-specification.vue?vue&type=template&id=535b1e7e&scoped=true&"
import script from "./form-specification.vue?vue&type=script&lang=js&"
export * from "./form-specification.vue?vue&type=script&lang=js&"
import style0 from "./form-specification.vue?vue&type=style&index=0&id=535b1e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b1e7e",
  null
  
)

export default component.exports